import React from 'react'
import styled from 'styled-components'

import { body } from 'styles/texts'

import Button from 'components/Button'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Text = styled.div`
  ${body};
  font-size: 17px;
  color: white;
  margin-top: 60px;
  width: 80%;
  text-align: center;
`

const Image = styled.img`
  margin: 60px 0;
  width: 80%;
  max-width: 509px;
`

class NotFound extends React.Component {
  componentDidMount() {
    document.body.style.backgroundColor = '#5f4b76'
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = ''
  }

  render() {
    return (
      <Wrapper>
        <Text>
          Uff da! Vi finner ikke siden du leter etter.{' '}
          <span role="img" aria-label="">
            😞
          </span>
        </Text>
        <Image src="/404.svg" alt="404" />
        <Button to="/">Gå til forsiden</Button>
      </Wrapper>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/pages/NotFound.js